import { OperatorConfig } from "..";

// INT
const sourcesConfig: OperatorConfig = {
  backoffice: {
    display: {
      "sidebar.menu.management.visits": true,
    },
  },
};

export default sourcesConfig;
